const PILLARS = [
  {
    icon: "ri-shield-check-line",
    title: "多源交叉验证",
    text: "每条实锤至少追溯两处独立来源，拒绝靠单张截图断章取义、带节奏。",
  },
  {
    icon: "ri-time-line",
    title: "还原完整时间线",
    text: "按时间顺序还原事件来龙去脉，不截取于己有利的片段去曲解原意。",
  },
  {
    icon: "ri-chat-3-line",
    title: "区分是非与网暴",
    text: "评的是行为，不是人肉与人身攻击。讲逻辑、讲证据，坚决反对网络暴力。",
  },
  {
    icon: "ri-question-answer-line",
    title: "让结论先留白",
    text: "真相需要时间发酵，重大事件先「让子弹飞」，不做抢跑式审判。",
  },
];

export default function MethodSection() {
  return (
    <section id="method" className="scroll-mt-20 bg-background-100/60 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-primary-600">METHOD</p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              吃瓜方法论
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              反差吃瓜局的四条内容铁律。我们相信，理性与证据，才是这场围观里最性感的品质。
            </p>
          </div>
          <div className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2 text-xs text-foreground-600 lg:inline-flex">
            <i className="ri-flashlight-fill text-accent-500" /> 拒绝断章取义 · 拒绝人肉网暴
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PILLARS.map((p, i) => (
            <div
              key={p.title}
              className="relative rounded-2xl border border-background-200/70 bg-background-50 p-6 transition-transform hover:-translate-y-1"
            >
              <span className="absolute right-5 top-4 font-heading text-4xl font-black text-background-200">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                <i className={`${p.icon} text-xl`} />
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}